import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '../icon/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import MainIcon from '../icon/FireGrip';
import { Link } from 'react-router-dom';
import { useAppContext } from "../config/context";

const routes = [
  {path: '/', name: 'Todo'},
  {path: '/reminders', name: 'Reminder'},
  {path: '/notes', name: 'Notes'},
  {path: '/kanban', name: 'Kanban'},
  {path: '/links', name: 'Links'},
  {path: '/instructions', name: 'Instructions'},
  {path: '/logs', name: 'Logs'},
];

function ResponsiveAppBar() {
  const { PLATFORM, handleLogout } = useAppContext();
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon color="white" />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {routes.map((route) => (
                <MenuItem key={route.path} onClick={handleCloseNavMenu}
                  className={route.path === window.location.pathname ? 'active' : ''}
                    component={Link} to={route.path}>
                  <Typography textAlign="center">{route.name}</Typography>
                </MenuItem>
              ))}
              {/* Mobile Screen */}
            </Menu>
          </Box>

          <MainIcon sx={{ display: 'flex', mr: 1 }} color="white" />
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: 'flex',
              flexGrow: { xs: 1, md: 'initial' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Notebook
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {routes.map((route) => (
              <Button
                key={route.path}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white', display: 'block' }}
                component={Link} to={route.path}
              >
                {route.name}
              </Button>
            ))}
            {/* Large Screen */}
          </Box>
          <Box sx={{ display: { xs: 'block', sm: 'block' } }}>
            {
              PLATFORM === "backend" ?
              <Button component={"a"} target="_blank" href="/home.html" sx={{ color: '#fff' }}>
                Credentials
              </Button> :
              <Button component={"a"} onClick={() => handleLogout()} sx={{ color: '#fff' }}>
                Logout
              </Button>
            }
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
